import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { AppointmentCard } from 'components/AppointmentCard';
import { AppointmentsBanner } from 'components/AppointmentsBanner';
import { ChatBanner } from 'components/ChatBanner';
import { useCoupons } from 'hooks/useFetchCoupons';
import { useFetchNextAppointments } from 'hooks/useFetchNextAppointments';
import { useUserStore } from 'stores/user';
import { AppointmentsTable } from './components/AppointmentsTable';
import { RecentPsychologists } from './components/RecentPsychologists';
import { RemainingSessions } from './components/RemainingSessions';

export const AppointmentsList = (): React.ReactElement => {
  const patient = useUserStore(state => state.user);
  const { isPending: isPendingAppointments, data: appointmentsData } = useFetchNextAppointments(
    patient?.id ?? ''
  );
  const { isLoading: isLoadingCoupons, coupons } = useCoupons();
  const userCanBookAppointments = patient?.canBookAppointments ?? false;

  const isInitialLoading =
    (isLoadingCoupons && !coupons) || (isPendingAppointments && !appointmentsData);

  return (
    <div className="flex flex-col gap-8">
      <div className="flex gap-4 max-am-xl:flex-col">
        <ChatBanner hideImage className="w-full" />
        {userCanBookAppointments && <AppointmentsBanner hideImage className="w-full" />}
      </div>
      {isInitialLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <RemainingSessions />
          <AppointmentCard patientId={patient?.id ?? ''} />
          <AppointmentsTable />
          <RecentPsychologists />
        </>
      )}
    </div>
  );
};
